var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[(!_vm.isSummaryView)?_c('div',[_c('p',{staticClass:"title font-weight-light",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('v-textarea',{attrs:{"rules":[
            function (v) { return !_vm.isRequired ||
              _vm.currentStep !== this$1.$props.pageNr ||
              (!!v && v.length > 0) ||
              'Please share your comments.'; }
          ],"outlined":""},model:{value:(_vm.verbatimText),callback:function ($$v) {_vm.verbatimText=$$v},expression:"verbatimText"}})],1):_c('div',{staticClass:"mt-10"},[_c('p',{staticClass:"title font-weight-black",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',[_vm._v(_vm._s(_vm.verbatimText))])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }